import React from "react";
import { Container } from "react-bootstrap";
import shipping from "../../../../Asset/hero-shipping-automation.svg";

const Third = () => {
  return (
    <>
      <section
        className="side-image-box-section pt-5"
        style={{ backgroundColor: "var(--light-primary-bg)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-1">
              <div className="info-content">
                <div className="title-paragraph">
                  Fintech Application Development
                </div>
                <p>
                  Our Fintech site and application development endeavors can
                  associate you with your clients, workers or accomplices right
                  where it is important — on their PCs, tablets and,
                  surprisingly, the telephones that your clients convey wherever
                  in their pockets.
                </p>
                <p>
                  These are a few instances of the Fintech tech benefits that we
                  give:
                </p>
                <ul className="check-list count_2 pt-4">
                  <li>
                    Application development incorporates portable, Progressive,
                    native and Java-based applications.
                  </li>
                  <li>
                    We foster applications for advertising, business insight,
                    HR, investigation, and many more.
                  </li>
                  <li>
                    Contingent upon the kind of use, applications we create can
                    run on iOS, Android and other normal working frameworks or
                    on any platform.
                  </li>
                  <li>We develop software for financial intuition needs.</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-2">
              <div className="info-img">
                <img alt="infoImage" src={shipping} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
